var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Informativo_UnidadeActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Informativo_UnidadeModule = class Informativo_UnidadeModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Informativo_UnidadeActions.POST_RANGE_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_Unidade/PostRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Informativo_UnidadeActions.POST_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_Unidade/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Informativo_UnidadeActions.PUT_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.put("Informativo_Unidade/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Informativo_UnidadeActions.DELETE_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Informativo_Unidade/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Informativo_UnidadeActions.DELETE_RANGE_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Informativo_Unidade/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Informativo_UnidadeActions.FILTER_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_Unidade/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Informativo_UnidadeActions.GET_INFORMATIVO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Informativo_Unidade/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Informativo_UnidadeActions.GETWITHDISABLED_INFORMATIVO_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Informativo_Unidade/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Informativo_UnidadeActions.GET_BY_ID_INFORMATIVO_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.get("Informativo_Unidade/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_UnidadeModule.prototype, _j, null);
Informativo_UnidadeModule = __decorate([
    Module
], Informativo_UnidadeModule);
export default Informativo_UnidadeModule;
//********** COMENTÁRIO GERADO EM: 16/05/2022 03:10:34 **********
//
//import infraService from "@/core/services/infraService";
//import JwtService from "@/core/services/JwtService";
//import {Informativo_UnidadeActions, Mutations} from "@/store/enums/StoreEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class Informativo_UnidadeModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//
//    @Action
//    [Informativo_UnidadeActions.POST_INFORMATIVO_UNIDADE] (data) {
//        return new Promise(resolve => {
//			infraService.post("Informativo_Unidade/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[Informativo_UnidadeActions.PUT_INFORMATIVO_UNIDADE] (data) {
//        return new Promise(resolve => {
//            infraService.put("Informativo_Unidade/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Informativo_UnidadeActions.DELETE_INFORMATIVO_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.delete("Informativo_Unidade/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Informativo_UnidadeActions.DELETE_RANGE_INFORMATIVO_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.delete("Informativo_Unidade/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Informativo_UnidadeActions.FILTER_INFORMATIVO_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.post("Informativo_Unidade/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Informativo_UnidadeActions.GET_INFORMATIVO_UNIDADE]() {
//        return new Promise(resolve => {
//            infraService.get("Informativo_Unidade/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [Informativo_UnidadeActions.GETWITHDISABLED_INFORMATIVO_UNIDADE]() {
//        return new Promise(resolve => {
//            infraService.get("Informativo_Unidade/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Informativo_UnidadeActions.GET_BY_ID_INFORMATIVO_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.get("Informativo_Unidade/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=Informativo_UnidadeModule.js.map